import React from 'react';

import { BaseIconProps } from '.';

export const Camera = ({ fill }: BaseIconProps) => (
  <path
    fill={fill}
    d="M964.3,231.4H810c-12.3,0.6-24-5.2-30.8-15.4l-73.3-92.6c-20.8-28.4-53.5-45.5-88.7-46.3H462.9
	c-36.4-0.1-70.8,17-92.6,46.3L300.9,216c-8,8.8-19,14.3-30.8,15.4H115.7C53,230.2,1.2,280.2,0,342.9c0,1.4,0,2.8,0,4.2v540
	c-1.2,62.7,48.8,114.6,111.5,115.7c1.4,0,2.8,0,4.2,0h848.5c62.7,1.2,114.6-48.8,115.7-111.5c0-1.4,0-2.8,0-4.2v-540
	c1.2-62.7-48.8-114.6-111.5-115.7C967.1,231.4,965.7,231.4,964.3,231.4z M540,848.5c-127.8,0-231.4-103.6-231.4-231.4
	S412.2,385.7,540,385.7s231.4,103.6,231.4,231.4C771,744.8,667.7,848.2,540,848.5z M906.4,462.9c-31.9,0-57.8-25.9-57.8-57.8
	s25.9-57.8,57.8-57.8c31.9,0,57.8,25.9,57.8,57.8C963.5,436.6,938,462.1,906.4,462.9z M540,462.9c-85.2,0-154.3,69.1-154.3,154.3
	S454.8,771.4,540,771.4c85.2,0,154.3-69.1,154.3-154.3l0,0C694,532,625.1,463.1,540,462.9z"
  />
);
